import { FoodsIcon, HelperBox } from "@foodpilot/foods";
import { Button, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ActionPlanFormGoal, ActionPlanFormScoreOptions } from "./useActionPlanForm";
import { NoGoals } from "./Goals/NoGoals";
import { GoalFields } from "./Goals/GoalFields";
import { Fragment } from "react/jsx-runtime";

type GoalBlockProps = {
    goals: ActionPlanFormGoal[];
    setGoals: (newGoals: ActionPlanFormGoal[]) => void;
    remainingScoreOptions: ActionPlanFormScoreOptions;
};
export const GoalBlockList = (props: GoalBlockProps) => {
    const { goals, setGoals, remainingScoreOptions } = props;

    const theme = useTheme();
    const { t } = useTranslation();

    const addEmptyBlock = () => {
        const newEmptyGoal: ActionPlanFormGoal = {
            rowId: goals.length,
            score: null,
            variation: null,
            simulationVaryAbsolute: null,
            simulationVaryPercentage: null,
            simulationType: "percentage",
        };
        setGoals([...goals, newEmptyGoal]);
    };

    return (
        <Stack gap={theme.spacing(1)}>
            <Typography variant="h5">{t("actionplan.trajectory.form.goal.indicator.title")}</Typography>
            {goals.length === 0 ?
                <NoGoals addOneGoal={addEmptyBlock} />
            :   <GoalBlocks
                    goals={goals}
                    setGoals={setGoals}
                    addOneGoal={addEmptyBlock}
                    remainingScoreOptions={remainingScoreOptions}
                />
            }
        </Stack>
    );
};

type GoalBlocksProps = {
    goals: ActionPlanFormGoal[];
    setGoals: (newGoals: ActionPlanFormGoal[]) => void;
    addOneGoal: () => void;
    remainingScoreOptions: ActionPlanFormScoreOptions;
};
const GoalBlocks = (props: GoalBlocksProps) => {
    const { goals, setGoals, addOneGoal, remainingScoreOptions } = props;

    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Stack gap={theme.spacing(2)}>
            {goals.map((goal, idx) => {
                return (
                    <Fragment key={`goal-${goal.rowId}-${idx}`}>
                        <GoalFields
                            goal={goal}
                            setGoal={(goal: ActionPlanFormGoal) => {
                                const newGoals = goals.with(goal.rowId, goal);
                                setGoals(newGoals);
                            }}
                            deleteGoal={(goal: ActionPlanFormGoal) => {
                                const newGoals = goals
                                    .filter((g) => g.rowId !== goal.rowId)
                                    .map((g, idx) => {
                                        return { ...g, rowId: idx };
                                    });
                                setGoals(newGoals);
                            }}
                            remainingScoreOptions={remainingScoreOptions}
                        />
                    </Fragment>
                );
            })}
            <Stack flexDirection={"row"} justifyContent={"start"} paddingLeft={theme.spacing(1)}>
                {remainingScoreOptions.scores.length > 0 ?
                    <Button variant="text" startIcon={<FoodsIcon size={2} icon="add" />} onClick={addOneGoal}>
                        {t("actionplan.trajectory.form.addgoal")}
                    </Button>
                :   <HelperBox>
                        <Typography variant="body-medium">{t("actionplan.allindicators.selected")}</Typography>
                    </HelperBox>
                }
            </Stack>
        </Stack>
    );
};
